<div [class]="divClass">
  <label *ngIf="showLabel" [class]="labelClass">{{ 'DropDowns.Label.Consignee' | translate }}</label>

  <laas-multiSelect
    *ngIf="isMultiple"
    appendTo="body"
    [style]="dropdownStyle"
    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
    [filter]="showFilter"
    [options]="filteredCustomers"
    [ngModel]="customerDataList"
    [virtualScroll]="virtualScroll"
    [itemSize]="59.2"
    (ngModelChange)="onChange($event)"
    [showToggleAll]="showToggleAll"
    (onFilter)="onFilterInput($event.filter)"
    [ngClass]="{'ng-invalid ng-dirty': isInvalid}">

    <ng-template pTemplate="selectedItems" let-value>
      <ng-container *ngIf="!value || value.length === 0; else showData">
        <span>
          {{ 'Common.Message.ChooseOption' | translate }}
        </span>
      </ng-container>
      <ng-template #showData>
        <span *ngFor="let val of value; first as isFirst">
          <ng-container *ngIf="!isFirst">, </ng-container>
          {{ val | optionsMapping : customerOptionsByPermission }}
        </span>
      </ng-template>
    </ng-template>
  </laas-multiSelect>

  <laas-dropdown
    *ngIf="isSingle"
    appendTo="body"
    [style]="dropdownStyle"
    [filter]="showFilter"
    placeholder="{{ 'Common.DropDown.Select' | translate}}"
    [options]="filteredCustomers"
    [showClear]="showClear"
    [virtualScrollItemSize]="40"
    [virtualScroll]="virtualScroll"
    [ngModel]="customerData"
    (ngModelChange)="onChange($event)"
    (onFilter)="onFilterInput($event.filter)"
    [ngClass]="{'ng-invalid ng-dirty': isInvalid}">
  </laas-dropdown>
</div>
